import { Directive } from '@angular/core';
import { FormControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';
import { CashCustomerCodeService } from '../../woo_services.module/video_code_validation/CashCustomerCodeService';

@Directive({
  selector: '[cashVideoCodeValidator]',
  providers: [{ provide: NG_VALIDATORS, useExisting: CashVideoCodeValidator, multi: true }],
  standalone: false,
})
export class CashVideoCodeValidator implements Validator {
  constructor(private cashCustomerCodeService: CashCustomerCodeService) {}

  validate(formControl: FormControl): ValidationErrors | null {
    return this.cashCustomerCodeService.validate(formControl.value);
  }
}
